export const NAME = 'employeeMessages'

export const CARRIER_MESSAGE_GET = 'carrierMessageGet'
export const CARRIER_MESSAGES_SEARCH_GET = 'carrierMessageSearchGet'
